import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export type PulverizationTreatment =
  | 'cromai_results'
  | 'total_area'
  | 'no_pulverizated'

export interface ConfirmPulverizationActivityPayload {
  pulverization_treatment?: PulverizationTreatment
  start_date: string
  end_date: string
  description: string
}

export async function confirmPulverizationActivity(
  activityId: string,
  payload: ConfirmPulverizationActivityPayload,
): Promise<void> {
  await companiesApi.patch(
    apiRoutes.confirmPulverizationActivity(activityId),
    payload,
  )
}
